import React from 'react';
import {
    InformationTitle,
    InformationDescription,
    InformationWrapper
} from '../../CampaignDetails.styles';
import { ProductsProps } from './Products.interface';
import { GridWrapper } from './Products.styles';

export function Products({ products }: ProductsProps) {
    return (
        <div>
            <InformationTitle>DoveMed Products</InformationTitle>
            <InformationWrapper>
                {products && 
                    <GridWrapper>
                        {products.map((product) => (
                            <InformationDescription key={product.id}>{product.displayName}</InformationDescription>
                        ))}
                    </GridWrapper>
                }
            </InformationWrapper>
        </div>
    )
}
